import { render, staticRenderFns } from "./SelectCheckBox.vue?vue&type=template&id=5985ba9b&scoped=true"
import script from "./SelectCheckBox.vue?vue&type=script&lang=ts"
export * from "./SelectCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectCheckBox.vue?vue&type=style&index=0&id=5985ba9b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985ba9b",
  null
  
)

export default component.exports